import React from 'react';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from './ui/carousel';
import { Camera } from 'lucide-react';

const StudioCarousel = () => {
  const studioImages = [
    {
      url: 'https://customer-assets.emergentagent.com/job_hertz-premium-build/artifacts/9mtnr6x1_IMG_3703.jpeg',
      title: 'Gravação de Podcast Profissional no Estúdio Hertz',
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_hertz-premium-build/artifacts/du3ios5k_IMG_1185.jpeg',
      title: 'Estúdio de Podcast - Vista Panorâmica',
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_hertz-premium-build/artifacts/6k08nfh3_IMG_1403.jpeg',
      title: 'Gravação de Podcast Profissional',
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_hertz-premium-build/artifacts/2c5misu8_IMG_1444.jpeg',
      title: 'Setup de Gravação Completo',
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_hertz-premium-build/artifacts/x7vnjnk3_IMG_1821.jpeg',
      title: 'Produção de Vídeo em Estúdio',
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_hertz-premium-build/artifacts/nfcq7ma0_IMG_2332.jpeg',
      title: 'Ambiente de Gravação Premium',
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_hertz-premium-build/artifacts/ar9g02tj_9e668159-70ef-4262-875f-2fe73d40ce40.jpg',
      title: 'Estúdio de Podcast - Vista Geral',
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_hertz-premium-build/artifacts/ucstm0ss_0002802f-ee60-468f-9b5b-1ecb2f15ec02.jpg',
      title: 'Gravação de Podcast',
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_hertz-premium-build/artifacts/gm29bggr_63274f00-a491-41df-aa60-219a14ba65bd.jpg',
      title: 'Sessão de Gravação',
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_hertz-premium-build/artifacts/yh8za7uf_74700ece-404f-40b6-b50a-038a1258cd5d.jpg',
      title: 'Estúdio de Gravação',
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_hertz-premium-build/artifacts/c9dc9gmt_ea3b7b63-a1d0-400f-9378-cbf880751670.jpg',
      title: 'Setup Profissional',
    },
  ];

  return (
    <section id="estudio" className="py-16 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 space-y-4">
          <div className="inline-block">
            <span className="text-[#ff6b35] font-semibold text-sm uppercase tracking-wider bg-[#ff6b35]/10 px-4 py-2 rounded-full">
              O Estúdio
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#1e3a5f]">
            Conheça nosso <span className="text-[#ff6b35]">espaço</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Estúdio de podcast e produção audiovisual em Brasília com equipamentos profissionais para criar conteúdo de alto nível
          </p>
        </div>

        {/* Carousel */}
        <div className="relative">
          <Carousel
            opts={{
              align: 'start',
              loop: true,
            }}
            className="w-full"
          >
            <CarouselContent>
              {studioImages.map((image, index) => (
                <CarouselItem key={index} className="md:basis-1/2 lg:basis-1/3">
                  <div className="p-2">
                    <div className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500">
                      {/* Image */}
                      <div className="aspect-square overflow-hidden bg-gray-100">
                        <img
                          src={image.url}
                          alt={image.title}
                          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                          loading="lazy"
                        />
                      </div>
                      
                      {/* Overlay */}
                      <div className="absolute inset-0 bg-gradient-to-t from-[#1e3a5f]/90 via-[#1e3a5f]/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-end">
                        <div className="p-6 w-full">
                          <div className="flex items-center space-x-2 text-white">
                            <Camera size={20} className="text-[#ff6b35]" />
                            <h3 className="font-semibold text-lg">{image.title}</h3>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
            <CarouselPrevious className="-left-12 bg-white shadow-lg border-2 border-[#1e3a5f]/20 hover:bg-[#1e3a5f] hover:text-white" />
            <CarouselNext className="-right-12 bg-white shadow-lg border-2 border-[#1e3a5f]/20 hover:bg-[#1e3a5f] hover:text-white" />
          </Carousel>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-12">
          {[
            { icon: Camera, label: 'Câmeras 4K', value: 'Múltiplas' },
            { icon: Camera, label: 'Iluminação', value: 'Profissional' },
            { icon: Camera, label: 'Tratamento', value: 'Acústico' },
            { icon: Camera, label: 'Localização', value: 'Centro BSB' },
          ].map((stat, index) => (
            <div
              key={index}
              className="text-center p-6 bg-white rounded-xl shadow-md hover:shadow-lg transition-shadow duration-300"
            >
              <stat.icon className="text-[#ff6b35] mx-auto mb-3" size={32} />
              <div className="text-2xl font-bold text-[#1e3a5f] mb-1">{stat.value}</div>
              <div className="text-gray-600 text-sm">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StudioCarousel;